import CustomTooltip from '../../../shared/CustomTooltip';
import {
    Box,
    Button,
    Grid,
    InputLabel,
    List,
    ListItem,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import React from 'react';
import { useGetPolicyListQuery } from '../../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../../shared/AuthRoles';
import { BaseExperiencePolicy, Policy } from '../../../types/policy';
import { Add, HelpOutline } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';
import FormAutocomplete from '../../../shared/FormAutocomplete';
import FormCheckbox from '../../../shared/FormCheckbox';

interface Props {
    policy?: BaseExperiencePolicy | null;
    experienceType: string;
}

const ExperiencePoliciesForm = ({ policy, experienceType }: Props) => {
    const { control } = useFormContext();

    const loggedInUser = UserRole();

    const { data: policies = [] } = useGetPolicyListQuery(
        loggedInUser?.company,
    );

    const filteredPolicies = policies.filter(
        (p: Policy) =>
            p.moduleTypes.includes(experienceType) ||
            p.moduleTypes.length === 0,
    );

    const options = filteredPolicies.map((policy: Policy) => ({
        label: policy?.name,
        value: policy?.id,
    }));

    return (
        <>
            <div>
                <InputLabel htmlFor='policy-id__input'>Policy</InputLabel>
                <FormAutocomplete
                    id='policy-id__input'
                    name={`policy.policyId`}
                    control={control}
                    options={options}
                    disabled={!experienceType}
                    placeholder={
                        !experienceType ? 'Select type of experience' : ''
                    }
                    PaperComponent={({ children }) => {
                        return (
                            <Paper>
                                <Button
                                    fullWidth
                                    size='large'
                                    sx={{
                                        justifyContent: 'flex-start',
                                        pl: 2,
                                        mt: 1,
                                    }}
                                    startIcon={<Add />}
                                    onMouseDown={() =>
                                        window.open('/newPolicy', '_blank')
                                    }
                                >
                                    Add New Policy
                                </Button>
                                {children}
                            </Paper>
                        );
                    }}
                />
            </div>
            <Box sx={{ display: 'flex', gap: 0.5 }}>
                <FormCheckbox
                    id='policy-requires-consent__input'
                    name={`policy.requiresConsent`}
                    control={control}
                    sx={{ p: 0 }}
                />
                <InputLabel htmlFor='policy-requires-consent__input'>
                    Collect users consent?{' '}
                    <CustomTooltip
                        title={
                            <Typography>
                                <List>
                                    <ListItem>
                                        By ticking this, the user has to consent
                                        before the reservation can be processed.
                                    </ListItem>
                                </List>
                            </Typography>
                        }
                        placement='right'
                    >
                        <HelpOutline sx={{ fontSize: '16px' }} />
                    </CustomTooltip>
                </InputLabel>
            </Box>
        </>
    );
};

export default ExperiencePoliciesForm;
